export const USER_LANGUAGE_STORAGE_KEY = 'user-language-storage-key' as const;
